import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 9h.01","key":"svg-1"}],["path",{"d":"M15 9h.01","key":"svg-2"}],["path",{"d":"M15 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}]]

const IconMoodSing = createReactComponent('outline', 'mood-sing', 'MoodSing', __iconNode);

export default IconMoodSing;